
import $router from '@/router'
import i18n from '@/i18n'
import { pick } from 'lodash-es'
import store from '@/store'
import $const from '@/constants'
import { sthFromLang } from '@/utils/base'

export const goWebsiteIndex = () => {
  store.commit('website/RESET_STATE')
  $router.push('/websiteSettings')
}

export const lineText = line => {
  let name = '', idx = ''
  if(line.indexOf('-')) {
    const arr = line.split('-')
    idx = arr[1]
    name = i18n.t(`website.${arr[0]}`)
  }
  return `${name}${idx?`-${idx}`:''}`
}

// 有专线默认专线，无专线默认第一个
export const defaultLine = options => {
  if(options.length) {
    const plusItem = options.find(item => item.indexOf('overseasplus') > -1)
    return plusItem ? plusItem : options[0]
  } else {
    return ''
  }
}

export const urlPatternConst = 'defined_by_security|^(wss?|https?)://[^/]+/.*'

// 后端数组转前端-单条数据
export const cacheParamToRecord = config => {
  return {
    ...pick(config, [
      'dataId',
      'priority',
    ]),
    radioTime: config?.radioTime * 1 || 0,
    cacheType: config?.cacheType * 1 || 0,
    commonType: config?.commonType || '.*',
    ignoreCase: config?.ignoreCase * 1 || 0,
    cacheHeadIgnore: config?.cacheHeadIgnore * 1 || 0,
    clientRefIgnore: config?.clientRefIgnore * 1 || 0,
    ignoreAuth: config?.ignoreAuth * 1 || 0,
    timeSelect: config?.timeSelect || 's',
    uriType: config?.uriType || '',
    fileTypeList: config?.fileTypes?.split(';')?.sort() || [],
    customFileTypes: config?.customFileTypes || '',
    contentType: config?.contentType || '',
    urlMatch: config?.urlMatch || '',
    cacheTime: config?.cacheTime || '',
    uaText: config?.uaText || '',
    ua: config?.ua * 1 || 0,
    extraUrl: 1,
    extraUrlText: config?.extraUrlText || '',
    reqHead: config?.reqHead * 1 || 0,
    reqHeadText: config?.reqHeadText || '',
    uriMatch: config?.uriMatch * 1 || 0
  }
}

// 将后端返回的数据转化为前端所需的数据
export const cacheParamsToList = data => {
  if (data?.length) {
    const result = []
    data.forEach(config => {
      result.push(cacheParamToRecord(config))
    })
    return result
  } else {
    return []
  }
}

// 将前端数据转化为后端参数
export const cacheListToParams = data => {
  if(data?.length) {
    const result = []
    data.forEach(config => {
      result.push({
        ...pick(config, [
          'priority',
          'cacheType',
          'commonType',
          'cacheHeadIgnore',
          'clientRefIgnore',
          'ignoreAuth',
          'timeSelect',
          'uriType',
          'customFileTypes',
          'contentType',
          'urlMatch',
          'cacheTime',
          'uaText',
          'ua',
          'extraUrlText',
          'reqHead',
          'reqHeadText',
          'uriMatch',
          'extraUrl'
        ]),
        radioTime: config?.radioTime * 1 || 0,
        ignoreCase: config?.ignoreCase * 1 || 0,
        dataId: config.dataId.includes('new_') ? '' : config.dataId,
        fileTypes: config?.fileTypeList.join(';')
      })
    })
    return result
  } else {
    return []
  }
}

// 后端转前端数据-单条数据格式化
export const requestParamToRecord = config => {
  return {
    ...pick(config, [
      'dataId',
      'ua',
      'exceptionUA',
      'priority'
    ]),
    range: config?.urlpattern === urlPatternConst ? 0 : 1,
    urlpattern: config.urlpattern === urlPatternConst ? '' : config.urlpattern,
    protocol: config?.protocol * 1 || 1,
    protocolCode: config?.protocol * 1 !== 3 ? config?.statusCode : '301',
    newUrlCode: config?.protocol * 1 === 3 ? config?.statusCode : '301',
    oldUrl: config?.oldUrl || '',
    newUrl: config?.newUrl || ''
  }
}

// 后端转前端数据
export const requestParamsToList = data => {
  if(data?.length) {
    const result = []
    data.forEach(config => {
      result.push(requestParamToRecord(config))
    })
    return result
  } else {
    return []
  }
}

// 前端转后端参数
export const requestListToParams = data => {
  if(data?.length) {
    const result = []
    data.forEach(config => {
      result.push({
        ...pick(config, [
          'ua',
          'exceptionUA',
          'priority',
          'protocol'
        ]),
        urlpattern: config?.range === 0 ? urlPatternConst : config.urlpattern,
        dataId: config.dataId.includes('new_') ? '' : config.dataId,
        statusCode: config?.protocol === 3 ? config?.newUrlCode : config?.protocolCode,
        oldUrl: config?.protocol === 3 ? config?.oldUrl : '',
        newUrl: config?.protocol === 3 ? config?.newUrl : ''
      })
    })
    return result
  } else {
    return []
  }
}

export const urlListToParams = data => {
  if(data?.length) {
    const result = []
    data.forEach(config => {
      let configItem = {
        ...pick(config, [
          'oldUrl',
          'newUrl',
          'priority',
        ]),
        dataId: config.dataId.includes('new_') ? '' : config.dataId,
        urlpattern: config?.range === 0 ? urlPatternConst : config.urlpattern,
        protocol: 3
      }
      // 初始化数据
      $const['Website/AdvancedMatchRangeOptions'].forEach(n => {
        configItem[n.value] = ''
      })
      // 赋值填写数据
      if (config.advancedList?.length) {
        config.advancedList.forEach(adItem => {
          const adItemOption = $const['Website/AdvancedMatchRangeOptions'].find(n => n.value === adItem.key)
          if (adItemOption) {
            if (adItemOption.type === 'country') {
              configItem[adItemOption.value] = adItem.list?.join(';')
            } else {
              configItem[adItemOption.value] = adItem.value
            }
          }
        })
      }
      result.push(configItem)
    })
    return result
  } else {
    return []
  }
}

export const urlParamsToRecord = config => {
  const configItem = {
    ...pick(config, [
      'dataId',
      'priority'
    ]),
    range: config?.urlpattern === urlPatternConst ? 0 : 1,
    urlpattern: config.urlpattern === urlPatternConst ? '' : config.urlpattern,
    oldUrl: config?.oldUrl || '',
    newUrl: config?.newUrl || '',
    advancedList: []
  }
  $const['Website/AdvancedMatchRangeOptions'].forEach(opt => {
    if (opt.value in config) {
      if (config[opt.value]) {
        configItem.advancedList.push({
          key: opt.value,
          value: opt.type === 'country' ? '' : config[opt.value],
          list: opt.type === 'country' ? (config[opt.value] ? config[opt.value]?.split(';') : []) : []
        })
      }
    }
  })
  return configItem
}

export const urlParamsToList = data => {
  if(data?.length) {
    const result = []
    data.forEach(config => {
      result.push(urlParamsToRecord(config))
    })
    return result
  } else {
    return []
  }
}

export const filterConfirmList = (data, key) => {
  return data.filter(n => {
    const rules = n[key]
    return rules.add.length || rules.update.length || rules.delete.length
  })
}

export const waapActOptionsFormatter = list => {
  if (list?.length) {
    return list.map(n => {
      if (n.actionCode) {
        return {
          id: n.actionCode,
          actionName: n[sthFromLang('actionName', 'actionEn')]
        }
      } else {
        return n
      }
    })
  } else {
    return []
  }
}

